import VueRouter from 'vue-router'
import App from './App';
import Landing from './Landing';
import Lokal from './Lokal.vue';
import BaseStation from './BaseStation';
import ErrorPage from './ErrorPage';

const routes = [
  { path: '/', component: BaseStation },
  { path: '/online', component: App },
  { path: '/lokal', component: Lokal },
  { path: '/auto-bewerten', component: Landing },
  { path: '*', component: ErrorPage },
]

const routerBaseName = process.env.NODE_ENV === 'development' ? '/' : '/auto-verkaufen/'

const router = new VueRouter({ routes, mode: 'history', base: routerBaseName })

export default router;



// WEBPACK FOOTER //
// ./src/router.js